import { useCallback } from 'react';
import { updateWorkspaceProjectPreference } from '../../helpers/firebaseHelper';
import { rootStore } from '../../mobx/rootStore';
import { CurrentProject } from '../../interfaces/ProjectInterface';

interface UseAccountingFileFiltersProps {
  currentProject: CurrentProject;
  onCloseFileOrderDropdown: () => void;
  params: { id: string };
}

export const useAccountingFileFilters = ({
  currentProject,
  onCloseFileOrderDropdown,
  params
}: UseAccountingFileFiltersProps) => {
  const onChangeFilesListType = useCallback(
    async (listType: number) => {
      await updateWorkspaceProjectPreference(params.id, { tasks_filter_type: { files: listType } });
      rootStore.projectStore.setFilesViewListType(listType);
    },
    [params.id]
  );

  const onChangeFileOrdering = useCallback(
    async (orderingType: number) => {
      currentProject?.setFileOrdering(orderingType);
      onCloseFileOrderDropdown();
      await updateWorkspaceProjectPreference(params.id, { tasks_filter_type: { fileOrdering: orderingType } });
    },
    [currentProject, onCloseFileOrderDropdown, params.id]
  );

  return { onChangeFileOrdering, onChangeFilesListType };
};
